module.exports = __webpack_public_path__ + "img/restaurant-demo-400x300.2a782ea2.jpg";